import { Injectable } from '@angular/core';
import { IAdapter } from 'src/app/lego-utils';
import { MaterialDataDomain } from 'src/app/models';
import {
  YPLMMATSRVMaterialData,
  YPLMMATSRVMaterialDataUpdate,
} from 'src/generated-clients/material';

@Injectable({
  providedIn: 'root',
})
export class MaterialDataAdapter implements IAdapter<
  MaterialDataDomain,
  YPLMMATSRVMaterialData,
  YPLMMATSRVMaterialDataUpdate
> {
  public get $select() {
    const propertyNames: Array<keyof YPLMMATSRVMaterialData> = [
      'MaterialNumber',
      'ResponsibleUser',
      'MainGroupTop',
    ];

    return [...propertyNames];
  }

  public adaptToDTO(header: Partial<MaterialDataDomain>): Partial<YPLMMATSRVMaterialDataUpdate> {
    return {
      ResponsibleUser: header.responsibleUser,
    };
  }

  public adaptToDomain(header: YPLMMATSRVMaterialData): MaterialDataDomain {
    return new MaterialDataDomain(
      header.MaterialNumber ?? '',
      header.ResponsibleUser ?? '',
      header.MainGroupTop ?? ''
    );
  }
}
